import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HomeIcon from "@mui/icons-material/Home";
import { Box, Grid, ListItemButton, Typography } from "@mui/material";
import * as React from "react";
import { ListStateIconTool } from "source/components/framework/List/ListStateIconTool";
import { GroupPermissionLevel } from "ui/Scripts/source/models/enums";
import { IUnitNode } from "../../../../../models/unit/unitNode";
import { TUnitPermission } from "source/models/unit/unitPermission";
import { Translations } from "ui/Scripts/source/models/translations";

export interface IUnitPermissionTreeNewProp {
    classes?: string;
    level?: number;
    unitNode: IUnitNode;
    selectedId?: string;
    isFirstNode: boolean;
    unitPermissions: TUnitPermission[];
    height?: string | number;
    onClick: (id: string) => void;
    onOpen: (id: string) => void;
}

export class UnitPermissionTreeNew extends React.Component<IUnitPermissionTreeNewProp, {}> {
    handleUnitNodeClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onClick(props.unitNode.id);
    };
    
    handleUnitNodeDoubleClick = (e) => {
        const props = this.props;
        if (e) {
            e.stopPropagation();
        }
        props.onOpen(props.unitNode.id);
    };

    render() {
        const props = this.props;
        const unitNode = props.unitNode;
        if (!unitNode) return null;
        const hasChildren = unitNode.children.length > 0;
        const hasVisibleChildren = hasChildren;
        const isRoot = unitNode.getIsRoot();
        let selectedId = props.selectedId;
        if (!props.selectedId && isRoot) {
            selectedId = unitNode.id;
        }
        const permission = unitNode.permission.permission;
        const permissionText = props.unitPermissions.find(i => i.level === permission &&
            i.levelA === unitNode.permission.additionalPermissionA &&
            i.levelB === unitNode.permission.additionalPermissionB &&
            i.levelC === unitNode.permission.additionalPermissionC)?.title ?? Translations.Unkown;
        return (
            <Box sx={{
                maxHeight: props.isFirstNode ? props.height : undefined,
                overflowX: "hidden",
                overflowY: "auto",
            }}>
                <ListItemButton
                    selected={selectedId === props.unitNode.id}
                    className={(!hasChildren ? " noChilds" : "") + (isRoot ? " root" : "") + (unitNode.getIsDisabled() ? " disabled" : "") + (unitNode.partnerCompanyIds.length > 0 ? " hasPartners" : "")}
                    onClick={this.handleUnitNodeClick}
                    onDoubleClick={this.handleUnitNodeDoubleClick}
                >
                    <Grid container alignItems="center">
                        <Grid item sm={5}>
                            <Box display="flex" alignItems="center" sx={{ paddingLeft: (10 * props.level).toString(10) + "px" }}>
                                {(!isRoot && !props.isFirstNode) &&
                                <>
                                    {hasVisibleChildren
                                        ? (
                                            <ExpandMoreIcon fontSize="small" />
                                        )
                                        : (
                                            <Box sx={{ width: "20px" }} />
                                        )}
                                </>
                                }
                                <HomeIcon sx={{ marginRight: ".5rem" }} />
                                <span className={"icon access level" + Math.min(unitNode.permission.permission, GroupPermissionLevel.Write).toString(10)}></span>
                                <Typography
                                    fontWeight={selectedId === props.unitNode.id ? 600 : 400}
                                    sx={{ marginLeft: ".5rem" }}
                                >
                                    {unitNode.name}
                                </Typography>
                                {unitNode.partnerCompanyIds.length > 0 && <Typography color="error" sx={{ marginLeft: ".5rem" }}>*</Typography>}
                            </Box>
                        </Grid>
                        <Grid item sm={7}>
                            <Box display="flex" className={(unitNode.permission.isExplicitPermission ? "" : " inherited")} onClick={() => this.handleUnitNodeDoubleClick(null)}>
                                {unitNode.permission.isExplicitPermission &&
                                    <ListStateIconTool noMargin />
                                }
                                {permissionText
                                    ? <Typography
                                        fontWeight={selectedId === props.unitNode.id ? 600 : 400}
                                        sx={{ color: unitNode.permission.isExplicitPermission ? "text.primary" : "text.secondary", marginLeft: unitNode.permission.isExplicitPermission ? ".5rem" : 0 }}
                                    >
                                        {permissionText}
                                    </Typography>
                                    : "&nbsp;"}
                            </Box>
                        </Grid>
                    </Grid>
                </ListItemButton>
                {unitNode.children.map((childUnitNode) =>
                    <UnitPermissionTreeNew
                        key={childUnitNode.id}
                        unitNode={childUnitNode}
                        selectedId={selectedId}
                        isFirstNode={false}
                        level={props.level ? (props.level + 1) : 1}
                        unitPermissions={props.unitPermissions}
                        onClick={props.onClick}
                        onOpen={props.onOpen}
                    />
                )}
            </Box>
        );
    }
}